import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getNews } from '../api/newsService';
import { NewsItem } from '../types/interfaces';

export default function useNews() {
  const { i18n } = useTranslation();
  const [news, setNews] = useState<NewsItem[]>([]);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const fetchNews = async () => {
      try {
        // Pasamos el idioma actual al service
        const data = await getNews(i18n.language);
        setNews(data);
      } catch (err: any) {
        setError('Error al obtener noticias');
      }
    };
    fetchNews();
  }, [i18n.language]);

  return { news, error };
}
